import React from 'react';
import PropTypes from 'prop-types';
import './../../../../index.scss';
import { Tooltip } from '@components/Tippy';
import { getTooltip } from '../../../../texts/tooltips';
import {getText} from '../../../../texts/texts';
const ButtonList = (props) => (
  <ul className="inline-list">
    {props.arr && props.arr.map(item => (
        <li key={item.id}>
        {/* <Tooltip content={item.tooltip}> */}
        <Tooltip content={getTooltip(item.tooltip)}>
          <button 
            className={`btn btn-light ${item.id === props.selectedId && 'ImageButton--active'}`}
            onClick={() => props.onClick(item)}
          >
            <span className={item.icon} />

            {item.title && <span>{getText(item.title)}</span>}
          </button>
        </Tooltip>
        </li>
    ))}
  </ul>
);


ButtonList.propTypes = {
  arr: PropTypes.array.isRequired,
  selectedId: PropTypes.string
};

export default ButtonList;



// WEBPACK FOOTER //
// ./src/views/Application/types/SafetyBarrier/ButtonList.js